// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1oE8y","text":"SelectPayment_text__1ynp4","title":"SelectPayment_title__Xh46l","btn":"SelectPayment_btn__3vH-z"};